import React, { useMemo, useState } from "react";
import makidoctor from "../../assets/cards/maki_doctor.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DropdownMenu from "../modals/menu";
import Paymentsmodal from "../modals/payments";
import AssignRoomModal from "../modals/assignroommodal";
import VisitStatusModal from "../modals/visitstatusmodal";
import PurposeOfVisitModal from "../modals/purposeofvisitmodal";
import ProviderModal from "../modals/Providermodal";
import AddNotesModal from "../modals/notemodal";
import FlagModal from "../modals/flagmodal";
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import {
  actionDropDownCalenderIcon,
  actionDropDownChatIconBig,
  actionDropDownSchedulerIconBig,
  filterIcon,
  intakeiconbig,
  vitalsiconbig,
} from "../modals/svgs";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  alertIcon,
  ChartIcon,
  COMPLETEDIcon,
  CROSSIcon,
  listFileIcon,
  NotesIcon,
  OrderIcon,
  actionDropDownCalenderIconbig,
  actionDollarIconbig,
} from "../modals/svgs";
import TasksModal from "../../tasks/Modals/TasksModal";
import { pendingIcon } from "../../orders/tabs/svg";
import { eventBus } from "../../utils/eventBus";
import { isCoverageNote, visitModel } from "./visitflow";
import { calculatePatientCopay } from "./patientcalculator";
import "./patientcard.css";
import { coverageStatus } from "./coveragestatus";
import {
  isSyntheticOrder,
  isActionableOrder,
  visitRowValues,
  orderBadge,
} from "./visitrow";
import { rpmTag } from "./rpmtag";
import { cardActionShown, cardBlockShown, cardDefaultPins, cardNotesBox, cardOrderNotes, patientPhotoUrl } from "../../config/practice";
import OrderNotes, { CardNotesBox, cardNoteView } from "./OrderNotes";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import { practiceFeatures } from "../../config/practice";
import { useSendFormsWizard } from "../../forms/staff/launch";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import { useStaffFormFill } from "../../forms/internal/launch";

const statusChipClasses = (label, active) => {
  if (!active) return "border-[#ECECEE] text-[#1D4ED8]";
  if (label === "Ready for Triage") return "border-[#A7F3D0] text-[#065F46]";
  if (label === "Cancelled") return "border-[#FECACA] text-[#991B1B]";
  if (label === "In-Office - Confirmed")
    return "border-[#E9D5FF] text-[#581C87]";
  if (label === "Ready for Representative")
    return "border-[#FEF08A] text-[#854D0E]";
  if (label === "Processing") return "border-[#E2E8F0] text-[#1E293B]";
  if (label === "Walk-in") return "border-[#DDD6FE] text-[#4C1D95]";
  if (["Injections", "Labs"].includes(label))
    return "border-[#FED7AA] text-[#9A3412]";
  if (label === "Checked Out") return "border-[#FDA4AF] text-[#9F1239]";
  if (label === "Ready for Provider") return "border-[#FBCFE8] text-[#9D174D]";
  if (label === "Ready for Checkout") return "border-[#C7D2FE] text-[#312E81]";
  if (label === "Ready for Nurse") return "border-[#A5F3FC] text-[#155E75]";
  if (label === "No Show") return "border-[#D1D5DB] text-[#1F2937]";
  if (label === "Active") return "border-[#BBF7D0] text-[#166534]";
  if (label === "Rescheduled") return "border-[#BFDBFE] text-[#1E40AF]";
  return "border-[#A2F4FD66] text-[#00786F]";
};

const CardView = ({
  setFetchedData,
  setSelectedCard,
       searchTerm,
   handleschedular,
  modalopen,
  insertdata,
  alldata,
  data,
  dob,
  setChat,
  fetchpcarddata,
  markAsComplete,
  markAscancel,
  onUpdateVisitStatus,
  onUpdateRoom,
  refreshDashboard,
  paymentdetails,
  setSelectedOrder,
  handleconfirmScheduleClick,
  scheduleStates,
  setToastSeverity,
  setToastMessage,
  setOpenToast,
}) => {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [visitModalOpen, setVisitModalOpen] = useState(false);
  const [roomModalOpen, setRoomModalOpen] = useState(false);
  const [ordersExpanded, setOrdersExpanded] = useState(false);
  const [isQuickOpen, setIsQuickOpen] = useState(false);
  const [totalOrders, setTotalOrders] = useState([]);
const [showMore, setShowMore] = useState(false);
const location =useLocation()
    const fromPatientId = location.state?.fromPatientId;
  // On the All tab (filter.tab null) a cancelled visit is greyed out; on a
  // status tab it keeps its normal look.
  const dimCancelled = !useSelector((state) => state.filter.tab);
  const homescreenprev = useSelector(
    (state) => state.userPrivileges.homescreen
  );
  const [purposeModalOpen, setPurposeModalOpen] = useState(false);
  const [providerModalOpen, setProviderModalOpen] = useState(false);
  const [localProvider, setLocalProvider] = useState(
    data.linked_provider || ""
  );
  const userConfig = useSelector((state) => state.userconfig);
  // Form Wizard: "Send Forms" (action id 10) opens it for this patient/visit.
  const [openSendForms, sendFormsWizard] = useSendFormsWizard();
  // Internal staff forms: "Staff Form" (action id 11) fills one for this patient/visit.
  const [openStaffForm, staffFormFill] = useStaffFormFill();
  const taskscreenprev = useSelector((state) => state.userPrivileges.taskrpm);
  const [isFlagOpen, setIsFlagOpen] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [noteDraft, setNoteDraft] = useState({
    assignee: "Provider",
    message: "",
  });

  const navigate = useNavigate();
  const reduxDate = useSelector((state) => state.filter.currentDate);

  // const startDateObj = new Date(data.startdate);
  // const formattedDate = useMemo(() => {
  //   const y = startDateObj.getFullYear();
  //   const m = String(startDateObj.getMonth() + 1).padStart(2, "0");
  //   const d = String(startDateObj.getDate()).padStart(2, "0");
  //   return `${y}-${m}-${d}`;
  // }, [data.startdate]);
  // const isSameDate = formattedDate === reduxDate;
const startDateObj = dayjs(data.startdate, "YYYY-MM-DD HH:mm:ss");

// redux date (assume format YYYY-MM-DD)
const dtObj = dayjs(reduxDate, "YYYY-MM-DD");
const isSameDate = startDateObj.isSame(dtObj, "day");
  const openPaymentModal = () => setIsPaymentModalOpen(true);
  const closePaymentModal = () => setIsPaymentModalOpen(false);
  const openNoteModal = () => setNoteModalOpen(true);
  const closeNoteModal = () => setNoteModalOpen(false);

  // -------- Orders / Tasks UI helpers (style-only; reads data from `data`) --------
  // The morning "The following are covered..." note repeats the coverage
  // chips; like the list card, it is not listed or counted as a task.
  const orders = (Array.isArray(data?.orders) ? data.orders : []).filter(
    (o) => !isCoverageNote(o)
  );
  const paymentdetailsArray = Array.isArray(paymentdetails)
    ? paymentdetails
    : [];

  const handleScheduleClick = (order) => {
    setSelectedOrder(order); // Set the selected order for confirmation
  };

  // const listedCount = orders.reduce((acc, order) => {
  //   const rawType = (order?.ordertype || "").trim();
  //   const isVisit = rawType.toUpperCase() === "VISIT";
  //   if (!isVisit) return acc + 1;
  //   let c = 0;
  //   if (order?.tov) c += 1;
  //   if (order?.tov2) c += 1;
  //   return acc + c;
  // }, 0);

  // Open rows while any real order is open, else every row, greyed. The
  // dashboard's display-only visit row (synthetic) is listed and counted but
  // never keeps the badge active (visitrow.js).
  const { count: listedCount, allInactive } = orderBadge(orders);

  const renderOrderRow = (order, label, value, key, source = null) => {
    const status = String(order?.status || "").toUpperCase();
    const isCompleted = status === "COMPLETED";
    const isCancelled = status === "CANCELLEDTASK";
    // Display-only visit row (no VISIT order, id null): a click does nothing.
    const synthetic = isSyntheticOrder(order);

    const matchedPatient = paymentdetailsArray.find(
      (p) => p.content === order?.ordername
    );

    return (
      <div
        key={key}
        className={`flex w-full items-center justify-between py-3 border-b border-gray-100 ${
          (isCompleted || isCancelled) && userConfig?.config?.tasks_completed
            ? "opacity-60"
            : ""
        }${synthetic ? " cursor-default" : ""}`}
        title={
          synthetic
            ? `${source?.title || "Level of visit"} (no visit order)`
            : undefined
        }
        onClick={synthetic ? (e) => e.stopPropagation() : undefined}
      >
        {/* Left Section: Label */}
        <div className="flex items-center min-w-[100px]">
        <div className="mr-2 flex items-center">
  {isCompleted ? (
    <span className="text-green-500">{COMPLETEDIcon}</span>
  ) : isCancelled ? (
    <span className="text-red-500">{CROSSIcon}</span>
  ) : (
    pendingIcon
  )}
</div>

          <span
            className={`uppercase font-inter text-xs font-normal ${
              (isCompleted || isCancelled) &&
              userConfig?.config?.tasks_completed
                ? "text-[#98A2B3]"
                : "text-[#6B7280]"
            }`}
          >
            {label}
          </span>
          {source && (
            <span
              title={source.title}
              className={`ml-1.5 px-1.5 rounded-md border text-[10px] font-semibold leading-4 ${
                source.kind === "ai"
                  ? "bg-[#e8eefb] text-[#2f5a9a] border-[#d2ddf4]"
                  : "bg-[#e5f5eb] text-[#23734a] border-[#cde8d7]"
              }`}
            >
              {source.text}
            </span>
          )}
        </div>

        {/* Middle Section: Value */}
        <div
          className={`flex-1 text-sm font-medium font-inter text-center truncate ${
            (isCompleted || isCancelled) && userConfig?.config?.tasks_completed
              ? "text-[#98A2B3]"
              : "text-[#000000]"
          }`}
        >
          {value || "-"}
        </div>

        {/* Right Section: Price */}
        {!!matchedPatient && userConfig?.config?.show_prices && (
          <div
            className={`text-right font-inter font-bold text-[16px] ${
              isCompleted || isCancelled ? "text-[#98A2B3]" : "text-[#F97316]"
            }`}
          >
            ${matchedPatient.insurance_cost}
          </div>
        )}
      </div>
    );
  };

  // RPM tag: green while readings come in, muted "RPM · inactive" when an
  // enrolled patient has sent none in 30 days (rpmtag.js).
  const rpm = cardBlockShown("rpm") ? rpmTag(data) : null;
  // Risk adjustment / quality measure flag (gated per practice; 7825: none).
  const qualityRisk = cardBlockShown("quality") ? data?.quality_risk_metrics : undefined;

  // clean insurance text (no trailing space, ellipsis only if needed)
  const insuranceClean = ((data.insurancename ?? "-") + "").trim();
  const insuranceShort =
    insuranceClean.length > 14
      ? `${insuranceClean.slice(0, 14)}…`
      : insuranceClean;
  const allActionsAll = [
    {
      id: 1,
      key: "Chart",
      icon: ChartIcon,
      label: "Charts",
      onClick: () => modalopen(data.id),
      visible: homescreenprev.includes("Chart"),
    },
    {
      id: 2,
      key: "Order",
      icon: OrderIcon,
      label: "Orders",
      onClick: () =>{
        if(!isSameDate){
setToastMessage('Please schedule an appointment')
setToastSeverity('info')
setOpenToast(true)
return
}
        navigate(`/orders/${data.appointmentid}/${data.startdate}/${(searchTerm||fromPatientId)?'filter':"all"}`)},
      visible: homescreenprev.includes("Order"),
    },
    {
      id: 3,
      key: "Notes",
      icon: NotesIcon,
      label: "Notes",
      onClick: openNoteModal,
      visible: homescreenprev.includes("Notes"),
    },
    {
      id: 4,
      key: "Take Payment",
      icon: actionDollarIconbig,
      label: "Payments",
      onClick: openPaymentModal,
      visible: homescreenprev.includes("Take Payment"),
    },
    {
      id: 5,
      key: "Imaging",
      icon: actionDropDownCalenderIconbig,
      label: "Imaging",
      onClick: () => insertdata(data),
      visible: true,
    },
    {
      id: 6,
      key: "Chat",
      icon: actionDropDownChatIconBig,
      label: "Chat",
      onClick: () => {
        setSelectedCard(data);
        setChat(true);
      },
      visible: true,
    },
    {
      id: 7,
      key: "Scheduler",
      icon: actionDropDownSchedulerIconBig,
      label: "Scheduler",
    onClick: () => {
        setSelectedCard(data);
      handleschedular(data)
      },
      visible: true,
    },
         {
          id: 8,
          key: "Vitals",
          icon: vitalsiconbig,
          label: "Vitals",
        onClick: () => {
      modalopen(data.id);
    
      setTimeout(() => {
        eventBus.emit("navigateToPriorVitals", { tab: 3 });
      }, 50); // or 100ms if needed
    } ,
          visible: homescreenprev.includes("Chart"),
        },
        {
              id: 9,
              key: "Intake",
              icon: intakeiconbig,
              label: "Intake",
            onClick: () => {
          modalopen(data.id);
        
          setTimeout(() => {
            eventBus.emit("navigateToPriorVitals", { tab: 3 ,internalTab:0});
          }, 50); // or 100ms if needed
        } ,
              visible: homescreenprev.includes("Chart"),
            },
    // Form Wizard (practiceFeatures().formWizard): never a default pin.
    ...(practiceFeatures().formWizard
      ? [
          {
            id: 10,
            key: "Send Forms",
            icon: <PostAddOutlinedIcon sx={{ fontSize: 22 }} />,
            label: "Send Forms",
            onClick: () => openSendForms(data, { dob }),
            visible: practiceFeatures().formWizard,
          },
        ]
      : []),
    // Internal staff forms (practiceFeatures().staffForms): never a default pin.
    ...(practiceFeatures().staffForms
      ? [
          {
            id: 11,
            key: "Staff Form",
            icon: <NoteAltOutlinedIcon sx={{ fontSize: 22 }} />,
            label: "Staff Form",
            onClick: () => openStaffForm(data, { dob }),
            visible: practiceFeatures().staffForms,
          },
        ]
      : []),
  ];
  // The practice's card action allowlist (7825: Notes, Take Payment,
  // Scheduler, Intake; 9928: every action).
  const allActions = allActionsAll.filter((a) => cardActionShown(a.key));
   const formatTime = (time) => {
    if (!time) return "-";

    const [hourStr, minute] = time.split(":");
    let hour = Number(hourStr);

    const period = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // convert 0 → 12

    return `${hour}:${minute} ${period}`;
  };
  const latestAppointment = (() => {
    if (!Array.isArray(data?.allappts)) return null;

    const grouped = {};

    data.allappts.forEach((appt) => {
      const date = dayjs(appt.startdate).format("YYYY-MM-DD");

      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(appt);
    });

    const result = Object.values(grouped).map((appointments) => {
      const valid = appointments.filter(
        (a) => a.visit_confirmation !== "Cancelled",
      );

      const list = valid.length ? valid : appointments;

      return list.sort(
        (a, b) => new Date(b.startdate) - new Date(a.startdate),
      )[0];
    });

    return result[0] || null; // 👈 THIS LINE
  })();
  // Get pinned actions based on user config. A practice with its own
  // default pins (7825) also falls back to them when its allowlist removed
  // any of the pins the user set (the pin menu keeps at least 3): [Chart,
  // Orders] left no buttons, and C-HIM's new-user seed [Intake, Vitals,
  // Chart, Order] left Intake alone.
  const userPinned =
    Array.isArray(userConfig?.config?.dash_pins) &&
    userConfig.config.dash_pins.length > 0
      ? userConfig.config.dash_pins
          .map((id) => allActions.find((act) => act.id === id))
          .filter(Boolean)
          .slice(0, 3)
          .reverse()
      : null;
  const pinnedActions =
    userPinned && (!cardDefaultPins() || userPinned.length >= Math.min(3, cardDefaultPins().length))
      ? userPinned
      : cardDefaultPins()
      ? cardDefaultPins().map((key) => allActions.find((act) => act.key === key)).filter(Boolean)
      : allActions.slice(0, 3);
  // The appointment note line: its "..." cut and its Show more share one test.
  const noteView = cardNoteView(data?.notes, showMore);


  /* The narrow card shares the wide card's design system: the root carries both
     .bmpc (tokens, type, chip and pill rules) and .bmnc, which flattens the wide
     card's three-column grid into a single column. */
  const { finalformattedTotalcopay } = calculatePatientCopay(data);
  const nextAppt =
    data?.next_appointment && data.next_appointment.startdate
      ? data.next_appointment
      : null;
  const nextApptText = nextAppt
    ? [
        nextAppt.provider,
        dayjs(nextAppt.startdate).format("MMM D, YYYY"),
        nextAppt.starttime
          ? dayjs(`2000-01-01 ${nextAppt.starttime}`).format("h:mm A")
          : "",
      ]
        .filter(Boolean)
        .join(" \u00b7 ")
    : "";
  const providerName =
    data?.linked_provider || latestAppointment?.linked_provider || "Provider";
  /* Three visible steps compressed from the five the timeline models, so the two
     views can never disagree about where the patient is. */
  const journey = useMemo(() => visitModel(data, new Date()), [data]);
  const steps3 = journey
    ? [
        { key: "checkin", label: "Check-in", done: journey.steps[0].done },
        { key: "provider", label: providerName, done: journey.steps[2].done },
        { key: "checkout", label: "Checkout", done: journey.steps[4].done },
      ]
    : null;
  const current3 = steps3 ? steps3.findIndex((s) => !s.done) : -1;
  const confirmation = String(latestAppointment?.visit_confirmation || "").trim();
  const statusTone = /checked out/i.test(confirmation)
    ? "out"
    : /cancel/i.test(confirmation)
      ? "off"
      : "on";

  return (
    <div
      className={`bmpc bmnc${
        latestAppointment?.visit_confirmation === "Cancelled"
          ? ` is-cancelled${dimCancelled ? " is-dimmed" : ""}`
          : qualityRisk
            ? " is-risk"
            : ""
      }`}
    >
      {/* A cancelled visit is marked by the red left accent alone (is-cancelled). */}
      {latestAppointment?.visit_confirmation !== "Cancelled" &&
      qualityRisk ? (
        <div className="bmpc-banner risk">
          Risk Adjustments and Quality Measure - Eligible
        </div>
      ) : null}

      <div className="nc-body">
        <div className="identity">
          <div className="nc-photo-wrap">
            <div
              onClick={() => {
                if (homescreenprev.includes("P-Card")) fetchpcarddata(data.id, data);
              }}
              className="nc-photo"
              title="Open P-Card"
            >
              <img
                src={patientPhotoUrl(data.patientid)}
                alt="profile"
                onError={(e) => {
                  e.target.style.visibility = "hidden";
                }}
              />
            </div>
            {finalformattedTotalcopay !== null &&
              finalformattedTotalcopay !== undefined && (
                <button
                  type="button"
                  className="copay-pill nc-copay"
                  title="Amount Due"
                  onClick={() => setIsPaymentModalOpen(true)}
                  // Follows the status picked in the payment modal.
                  style={{ background: coverageStatus(data?.deductiblemet).color }}
                >
                  <span className="copay-pill-cap">{coverageStatus(data?.deductiblemet).label}</span>
                  <span className="copay-pill-amt">
                    ${finalformattedTotalcopay}
                  </span>
                </button>
              )}
          </div>

          <div className="pinfo">
            <div className="nc-name-row">
              {/* Name opens the P-Card, same privilege gate as the photo. */}
              <h2
                className="nc-name cursor-pointer hover:underline"
                title="Open P-Card"
                onClick={() => {
                  if (homescreenprev.includes("P-Card")) {
                    fetchpcarddata(data.id, data);
                  }
                }}
              >{`${data.firstname} ${data.lastname}`}</h2>
              <button
                type="button"
                className="nc-room"
                title="Assign Room"
                onClick={() => {
                  if (homescreenprev.includes("Room Assignment")) {
                    setRoomModalOpen(true);
                  }
                }}
              >
                {/* Same control as the list card: room label + round "+". */}
                <span className="nc-room-label">
                  {(data?.room_no || "-").replace(/^waiting room$/i, "Waiting")}
                </span>
                <span className="nc-room-plus" aria-hidden="true">+</span>
              </button>
            </div>
            <button
              type="button"
              className={`nc-status ${statusTone}`}
              title="Update Visit Status"
              onClick={() => {
                if (homescreenprev.includes("Visit Confirmation")) {
                  setVisitModalOpen(true);
                }
              }}
            >
              {confirmation || "Visit Status"}
            </button>
            {/* Record number with dev's RPM tag beside it. */}
            <div className="demographics flex items-center gap-2">
              #{data.patientid || "-"}
              {rpm && (
                <span
                  onClick={() => navigate(`/rpm?pid=${data?.patientid}`)}
                  title={rpm.title || undefined}
                  className={`${
                    rpm.active
                      ? "bg-[#e7f8ee] text-[#17a34a]"
                      : "bg-[#F2F4F7] text-[#667085]"
                  } text-[9px] font-semibold tracking-[0.02em] rounded-[4px] px-[6px] py-[2px] font-inter cursor-pointer whitespace-nowrap`}
                >
                  {rpm.label}
                </span>
              )}
            </div>
            <div className="demographics">{insuranceShort}</div>
            <div className="demographics">
              DOB:{" "}
              {dayjs((dob || data.dob)?.trim()).format("MMMM D, YYYY") || "-"}
            </div>
            {!isSameDate && (
              <div className="demographics nc-otherdate">
                {actionDropDownCalenderIcon}
                {dayjs(data?.startdate).format("MM-DD-YYYY")}
              </div>
            )}
          </div>
        </div>

        <div className="appointment nc-appt">
          <span className="time">
            {formatTime(data?.starttime || latestAppointment?.starttime) || "-"}
          </span>
          <button
            type="button"
            className="provider-value nc-provider"
            title="Update Provider"
            onClick={() => {
              if (homescreenprev.includes("Change Provider")) {
                setProviderModalOpen(true);
              }
            }}
          >
            <img src={makidoctor} alt="" className="nc-doc" />
            {providerName}
          </button>
          {data?.purpose && (
            <button
              type="button"
              className="visit-type nc-visit"
              title="Update Type of Visit"
              onClick={() => setPurposeModalOpen(true)}
            >
              {data.purpose}
            </button>
          )}
        </div>

        {nextAppt ? (
          <div className="next-appt nc-next">
            <span className="next-appt-icon">{actionDropDownCalenderIcon}</span>
            <div className="next-appt-text">
              <span className="next-appt-cap">Next Appointment</span>
              <span className="next-appt-val">{nextApptText}</span>
            </div>
          </div>
        ) : steps3 ? (
          <div className="nc-journey">
            {steps3.map((s, i) => (
              <React.Fragment key={s.key}>
                <div
                  className={`nc-step${
                    s.done ? " done" : i === current3 ? " current" : " future"
                  }`}
                >
                  <span className="nc-dot">
                    {s.done ? (
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <polyline
                          points="20 6 9 17 4 12"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : null}
                  </span>
                  <span className="nc-step-label">{s.label}</span>
                </div>
                {i < steps3.length - 1 && (
                  <span
                    className={`nc-link${
                      steps3[i + 1].done || i + 1 === current3 ? " lit" : ""
                    }`}
                  />
                )}
              </React.Fragment>
            ))}
          </div>
        ) : null}

        {/* Orders / Tasks: gated per practice (7825: order notes below instead) */}
        {cardBlockShown("orders") && (
        <>
        <div className="nc-orders-head">
          <span className="nc-orders-cap">Orders/Tasks</span>
          <span
            className={`count${
              listedCount > 0 && !allInactive ? "" : " zero"
            }`}
          >
            {listedCount}
          </span>
          <button
            type="button"
            onClick={() => setOrdersExpanded((v) => !v)}
            aria-label="Toggle orders"
            aria-expanded={ordersExpanded}
            className="nc-orders-toggle"
            title={ordersExpanded ? "Collapse" : "Expand"}
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M6 9l6 6 6-6"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {ordersExpanded && (
          <button
            className="h-[210px] w-full overflow-y-auto custom-scrollbar pr-1 focus:outline-none flex flex-col justify-start items-start text-left"
            onClick={() => {
              // The quick view acts on real orders; only the display-only
              // visit row means nothing to open.
              if (!orders.some(isActionableOrder)) return;
              setTotalOrders(orders);
              setIsQuickOpen(true);
            }}
          >
            {orders.length === 0 ? (
              <div className="flex w-full flex-col justify-center items-center h-full text-center py-8">
                <div className="mb-3">{listFileIcon}</div>

                <p className="text-[#6B7280] text-sm font-medium font-inter mb-1">
                  No orders yet
                </p>

                <p className="text-[#9CA3AF] text-xs font-normal font-inter">
                  Orders will appear here when added
                </p>
              </div>
            ) : (
              <div className="flex flex-col justify-between items-start w-full">
                {[...orders]
                  .sort((a, b) => {
                    const getOrderRank = (status) => {
                      const s = String(status).toUpperCase();
                      if (s === "COMPLETED") return 2; // middle
                      if (s === "PENDING" || s === "CANCELLEDTASK") return 3; // last
                      return 1; // normal first
                    };
                    return getOrderRank(a.status) - getOrderRank(b.status);
                  })
                  .map((order, idx) => {
                    const rawType = (order?.ordertype || "").trim();
                    const isVisit = rawType.toUpperCase() === "VISIT";
                    const isNotes = rawType.toLowerCase() === "notes";
                    const rowKey =
                      order?.id ??
                      `${isSyntheticOrder(order) ? "synthetic" : "row"}-${idx}`;
                    const typeLabel =
                      rawType.charAt(0).toUpperCase() +
                      rawType.slice(1).toLowerCase();

                    const name = order?.ordername || "-";
                    const MAX_CHARS = 35;
                    const clipped =
                      name.length > MAX_CHARS
                        ? `${name.slice(0, MAX_CHARS)}…`
                        : name;

                    if (!isVisit) {
                      return renderOrderRow(
                        order,
                        isNotes
                          ? `${typeLabel} ${order?.user_role || ""}`.trim()
                          : typeLabel,
                        clipped,
                        rowKey
                      );
                    }

                    // The level (with who set it: AI or Provider) and the
                    // wellness slot, each only if it exists.
                    return (
                      <React.Fragment key={rowKey}>
                        {visitRowValues(order).map((v) =>
                          renderOrderRow(
                            order,
                            "Visit",
                            v.value,
                            `${rowKey}-${v.slot}`,
                            v.source
                          )
                        )}
                      </React.Fragment>
                    );
                  })}
              </div>
            )}
          </button>
        )}
        </>
        )}
   {cardNotesBox() ? (
     // 7825: OSA's notes box (appointment note + order notes, no cut).
     <CardNotesBox data={data} setFetchedData={setFetchedData} setToastMessage={setToastMessage}
       setToastSeverity={setToastSeverity} setOpenToast={setOpenToast} />
   ) : data?.notes?.trim()?<div className="flex flex-col gap-1 w-full">
  <div className="bg-[#F9FAFB] rounded-md p-2.5 relative">
    <span className="font-[400] ml-1 w-full flex font-inter text-xs text-[#62748E] mb-2">
      Notes
    </span>

    <div className="flex text-left items-start gap-1">
      <div className="pt-[2px]">{alertIcon}</div>

      <span className="text-sm font-inter font-normal text-[#BB4D00]">
        {/* "Notes: " + the note, cut at 80 unless Show more (OrderNotes.cardNoteView) */}
        {noteView.text}
      </span>
    </div>

    {/* Show more / Show less: whenever the line above is cut */}
    {noteView.long && (
      <button
        onClick={() => setShowMore(!showMore)}
        className="absolute bottom-1 right-2 text-[12px] font-inter"
        style={{ color: "#50869A" }}
      >
        {showMore ? "Show less" : "Show more"}
      </button>
    )}
  </div>
</div>:<div className="flex flex-col  gap-1 w-full">
  
  </div>}

      {cardOrderNotes() && !cardNotesBox() && (
        <div className="px-3">
          <OrderNotes data={data} setFetchedData={setFetchedData} setToastMessage={setToastMessage}
            setToastSeverity={setToastSeverity} setOpenToast={setOpenToast} />
        </div>
      )}

      {/* Bottom actions */}
      <div className="bmnc-actions">
        {pinnedActions.map((action) => (
          <div key={action.id} className="relative group">
            <button
              onClick={action.onClick}
              className={`${
                (action.key === "Notes" && noteModalOpen) ||
                (action.key === "Take Payment" && isPaymentModalOpen)
                  ? "bg-[#1D2951] text-white"
                  : "bg-[#F9FAFB]"
              } h-[56px] w-[56px] flex justify-center items-center rounded-[12px] cursor-pointer hover:bg-[#1D2951] hover:text-white transition`}
            >
              {action.icon}
            </button>
            <span className="absolute top-[60px] left-1/2 -translate-x-1/2 bg-[#1D2951] text-white text-xs font-medium py-1 px-2 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 whitespace-nowrap">
              {action.label}
            </span>
          </div>
        ))}

        {homescreenprev.includes("Actions") && (
          <div className="">
            <DropdownMenu
              isSameDate={isSameDate}
                 setToastSeverity={setToastSeverity}
  setToastMessage={setToastMessage}
  setOpenToast={setOpenToast}
              data={data}
              insertdata={insertdata}
              openPaymentModal={openPaymentModal}
              openNoteModal={openNoteModal}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              homescreenprev={homescreenprev}
              type={"under"}
              setSelectedCard={setSelectedCard}
              setChat={setChat}
               handleschedular={ handleschedular}
               modalopen={modalopen}
               searchTerm={searchTerm}
               loc={'card'}
            />
          </div>
        )}
      </div>

      {/* Modals (unchanged functionality) */}
      {visitModalOpen && (
        <VisitStatusModal
          open={visitModalOpen}
          current={data.visit_confirmation || ""}
          onClose={() => setVisitModalOpen(false)}
          selectedCard={data}
          setFetchedData={setFetchedData}
          setVisitModalOpen={setVisitModalOpen}
        />
      )}

      {roomModalOpen && (
        <AssignRoomModal
          setRoomModalOpen={setRoomModalOpen}
          setFetchedData={setFetchedData}
          open={roomModalOpen}
          currentRoom={data.room_no || ""}
          onClose={() => setRoomModalOpen(false)}
          selectedCard={data}
          alldata={alldata}
        />
      )}

      {purposeModalOpen && (
        <PurposeOfVisitModal
          open={purposeModalOpen}
          setFetchedData={setFetchedData}
          setPurposeModalOpen={setPurposeModalOpen}
          onClose={() => setPurposeModalOpen(false)}
          selectedCard={data}
        />
      )}

      {providerModalOpen && (
        <ProviderModal
          open={providerModalOpen}
          selectedCard={data}
          onClose={() => setProviderModalOpen(false)}
          setFetchedData={setFetchedData}
          setProviderModalOpen={setProviderModalOpen}
        />
      )}

      {noteModalOpen && (
        <AddNotesModal
          open={noteModalOpen}
          defaultAssignee={noteDraft.assignee}
          defaultMessage={noteDraft.message}
          setNoteModalOpen={setNoteModalOpen}
          setFetchedData={setFetchedData}
          selectedCard={data}
          refreshDashboard={refreshDashboard}
        />
      )}

      {isPaymentModalOpen && (
        <Paymentsmodal
       
          data={data}
          
             setFetchedData={setFetchedData}
   alldata={alldata}
        
         
fetchedData={alldata}
            
            closePaymentModal={closePaymentModal}
        />
      )}

      <FlagModal
        open={isFlagOpen}
        defaultText=""
        defaultStatus="unresolved"
        onClose={() => setIsFlagOpen(false)}
        onUpdate={({ text, status }) => {
          setIsFlagOpen(false);
        }}
      />

      {isQuickOpen && (
        <TasksModal
          setFetchedData={setFetchedData}
          setToastSeverity={setToastSeverity}
          setToastMessage={setToastMessage}
          setOpenToast={setOpenToast}
          handleconfirmScheduleClick={handleconfirmScheduleClick}
          scheduleStates={scheduleStates}
          closetaskModal={() => {
            setIsQuickOpen(false);
          }}
          handleScheduleClick={handleScheduleClick}
          task={totalOrders}
          markAsComplete={markAsComplete}
          markAscancel={markAscancel}
          data={data}
        />
      )}
      {sendFormsWizard}
      {staffFormFill}
    </div>
    </div>
  );
};

export default CardView;
